export default {
  methods: {
    imageExists(image_url) {
      if (!image_url) return false;
      const http = new XMLHttpRequest();
      http.open('HEAD', image_url, false);
      http.send();
      return http.status !== 404;
    },
  },
  computed: {
    playerNationality() {
      if (this.player && this.player.nationality_id) {
        return this.$t(`nationalities[${this.player.nationality_id}]`);
      }
      return '';
    },
    playerPosition() {
      if (this.player && this.player.position_id) {
        return this.$t(`player.positions.${this.player.position_id.toString()}`);
      }
      return '';
    },
    playerName() {
      if (this.player && this.player.player_name) {
        var NameArrayHome = this.player.player_name.split(',');
        var lastArrayName = NameArrayHome[0].split(' ');
        var ArrayName = NameArrayHome[1].trim().split(' ');
        var lastNameHome = '';
        if (lastArrayName.length == 2 || lastArrayName.length == 1) {
          if (lastArrayName[0].length < 4) {
            lastNameHome = lastArrayName[0] + ' ' + lastArrayName[1];
          } else {
            lastNameHome = lastArrayName[0];
          }
        } else {
          if (lastArrayName.length == 3) {
            lastNameHome = lastArrayName[0] + ' ' + lastArrayName[1];
          } else {
            if (lastArrayName.length == 4) {
              lastNameHome = lastArrayName[1] + ' ' + lastArrayName[2] + ' ' + lastArrayName[3];
            }
          }
        }

        lastNameHome = lastNameHome.replace(',', '');
        return ArrayName[0] + ' ' + lastNameHome;
      }
      return '';
    },
  },
};
